//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import ecommerceIntegrationsConfigureTemplate from '@legacy-components/ecommerce-integrations/ecommerce-integrations-configure.html';

(function() {
  angular.module('curalate').component('ecommerceIntegrationsConfigure', {
    bindings: {
      magentoFormValues: '=',
      shopifyFormValues: '=',
      continueCallback: '&',
      clientIntegration: '<',
      credentialsInvalid: '<',
    },
    template: ecommerceIntegrationsConfigureTemplate,
    controller: [
      'EcommerceIntegrationsOptions',
      function(
                EcommerceIntegrationsOptions,
            ) {
        this.integrationOptions = EcommerceIntegrationsOptions;

        this.$onInit = () => {
          if (this.clientIntegration === 'ecommerce_integrations_magento') {
            this.ecommerceSetupLink = 'https://support.bazaarvoice.com/s/article/Setting-up-a-Product-Catalog-via-Magento-2';
          } else if (this.clientIntegration === 'ecommerce_integrations_shopify') {
            this.ecommerceSetupLink = 'https://support.bazaarvoice.com/s/article/Setting-up-a-Product-Catalog-via-Shopify';
          } else {
            this.ecommerceSetupLink = 'http://developers.curalate.com/guide/product-catalogs/';
          }
        };
      }],
  });
})();
